'use client';

import { useEffect, useRef } from 'react';

import { runColdStart } from '@/activity-orchestration/scenes/cold-start';
import { runSessionBootstrap } from '@/providers/auth/run-session-bootstrap';

/** session 就绪后触发一次冷启拉取；ref 防止 Strict Mode 重复调度。 */
export default function ActivityColdStartBootstrap() {
    // 是否已调度过冷启链
    const startedRef = useRef(false);

    useEffect(() => {
        if (startedRef.current) {
            return;
        }
        startedRef.current = true;

        runSessionBootstrap()
            .then(() => runColdStart())
            .catch(error => {
                console.error('[ActivityColdStartBootstrap] cold start failed', error);
            });
    }, []);

    return null;
}
